@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.`init`.InitKobwebContext
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Any
import kotlin.Suppress
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import com.sddamico.draftmachine.components.layouts.PageLayout as _com_sddamico_draftmachine_components_layouts_PageLayout
import com.sddamico.draftmachine.pages.HomePage as _com_sddamico_draftmachine_pages_HomePage
import com.sddamico.draftmachine.pages.LoginPage as _com_sddamico_draftmachine_pages_LoginPage
import com.sddamico.draftmachine.pages.SettingsPage as _com_sddamico_draftmachine_pages_SettingsPage
import com.sddamico.draftmachine.pages.draft.DraftBoardPage as _com_sddamico_draftmachine_pages_draft_DraftBoardPage
import com.sddamico.draftmachine.pages.draft.DraftRoomPage as _com_sddamico_draftmachine_pages_draft_DraftRoomPage
import com.sddamico.draftmachine.pages.draft.DraftSettingsPage as _com_sddamico_draftmachine_pages_draft_DraftSettingsPage
import com.sddamico.draftmachine.pages.draft.NewDraftPage as _com_sddamico_draftmachine_pages_draft_NewDraftPage
import com.sddamico.draftmachine.pages.league.LeagueSettingsPage as _com_sddamico_draftmachine_pages_league_LeagueSettingsPage
import com.sddamico.draftmachine.pages.pools.PoolDetailPage as _com_sddamico_draftmachine_pages_pools_PoolDetailPage
import com.sddamico.draftmachine.pages.pools.PoolNewPage as _com_sddamico_draftmachine_pages_pools_PoolNewPage
import com.sddamico.draftmachine.pages.pools.PoolsPage as _com_sddamico_draftmachine_pages_pools_PoolsPage
import com.sddamico.draftmachine.pages.settings.AlertsPage as _com_sddamico_draftmachine_pages_settings_AlertsPage

private val LayoutScopeLocal: ProvidableCompositionLocal<Any?> = compositionLocalOf<Any?> { null }

@Composable
private fun <T : Any> currentLayoutScope(): T {
    @Suppress("UNCHECKED_CAST")
    return LayoutScopeLocal.current as? T
        ?: error("Unexpected between Page/Layout scope and the parent Layout which it is providing it. Please report this issue to the Kobweb developers.")
}

@Composable
private fun <T : Any> provideLayoutScope(layoutScope: T, content: @Composable () -> Unit) {
    androidx.compose.runtime.CompositionLocalProvider(LayoutScopeLocal provides layoutScope, content = content)
}

public fun main() {
    AppGlobals.initialize(mapOf("title" to "The Draft Machine"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "com.sddamico.draftmachine.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _com_sddamico_draftmachine_components_layouts_PageLayout(pageCtx) {
                provideLayoutScope(this) {
                    pageMethod(pageCtx)
                }
            }
        }
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _com_sddamico_draftmachine_pages_HomePage()
        }
        ctx.router.register(
            "/draft/new",
        ) { pageCtx -> 
            _com_sddamico_draftmachine_pages_draft_NewDraftPage()
        }
        ctx.router.register(
            "/draft/{id}",
        ) { pageCtx -> 
            _com_sddamico_draftmachine_pages_draft_DraftRoomPage()
        }
        ctx.router.register(
            "/draft/{id}/board",
        ) { pageCtx -> 
            _com_sddamico_draftmachine_pages_draft_DraftBoardPage()
        }
        ctx.router.register(
            "/draft/{id}/settings",
        ) { pageCtx -> 
            _com_sddamico_draftmachine_pages_draft_DraftSettingsPage()
        }
        ctx.router.register(
            "/league/{id}/settings",
        ) { pageCtx -> 
            _com_sddamico_draftmachine_pages_league_LeagueSettingsPage()
        }
        ctx.router.register(
            "/login",
        ) { pageCtx -> 
            _com_sddamico_draftmachine_pages_LoginPage()
        }
        ctx.router.register(
            "/pools/",
        ) { pageCtx -> 
            _com_sddamico_draftmachine_pages_pools_PoolsPage()
        }
        ctx.router.register(
            "/pools/new",
        ) { pageCtx -> 
            _com_sddamico_draftmachine_pages_pools_PoolNewPage()
        }
        ctx.router.register(
            "/pools/{id}",
        ) { pageCtx -> 
            _com_sddamico_draftmachine_pages_pools_PoolDetailPage()
        }
        ctx.router.register(
            "/settings",
        ) { pageCtx -> 
            _com_sddamico_draftmachine_pages_SettingsPage()
        }
        ctx.router.register(
            "/settings/alerts",
        ) { pageCtx -> 
            _com_sddamico_draftmachine_pages_settings_AlertsPage()
        }

        com.sddamico.draftmachine.initKobweb(ctx)
    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("headline-text", com.sddamico.draftmachine.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", com.sddamico.draftmachine.SubheadlineTextStyle)
        ctx.theme.registerStyle("card", com.sddamico.draftmachine.CardStyle)
        ctx.theme.registerStyle("primary-button", com.sddamico.draftmachine.PrimaryButtonStyle)
        ctx.theme.registerStyle("app-frame-column", com.sddamico.draftmachine.components.layouts.AppFrameColumnStyle)
        ctx.theme.registerStyle("page-content", com.sddamico.draftmachine.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("app-header", com.sddamico.draftmachine.components.sections.AppHeaderStyle)
        ctx.theme.registerStyle("app-header-content", com.sddamico.draftmachine.components.sections.AppHeaderContentStyle)
        ctx.theme.registerStyle("app-header-mobile", com.sddamico.draftmachine.components.sections.AppHeaderMobileStyle)
        ctx.theme.registerStyle("app-header-desktop", com.sddamico.draftmachine.components.sections.AppHeaderDesktopStyle)
        ctx.theme.registerStyle("code-input-row", com.sddamico.draftmachine.components.widgets.CodeInputRowStyle)
        ctx.theme.registerStyle("pressable", com.sddamico.draftmachine.ds.PressableStyle)
        ctx.theme.registerStyle("menu-item", com.sddamico.draftmachine.ds.overlays.MenuItemStyle)
        com.sddamico.draftmachine.initColorMode(ctx)
        com.sddamico.draftmachine.initTheme(ctx)
        com.sddamico.draftmachine.ds.initDmBase(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.sddamico.draftmachine.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
